module.exports = __webpack_public_path__ + "img/17.5d3b6d58.png";